import React, { useState } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import { Form } from 'react-bootstrap'
import api from '../../api/axios'
import Message from '../../components/Message'
import Loader from '../../components/Loader'

function ForgotPassword() {
  const [email, setEmail] = useState('')
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(null)
  const [success, setSuccess] = useState(false)
  const navigate = useNavigate()

  const handleSubmit = async (e) => {
    e.preventDefault()
    setLoading(true)
    setError(null)
    setSuccess(false)

    try {
      await api.post('/users/password-reset/', { email })
      setSuccess(true)
      setEmail('')

      // Redirect to login after 3 seconds
      setTimeout(() => {
        navigate('/login')
      }, 3000)
    } catch (err) {
      setError(err.response?.data?.detail || 'Błąd przetwarzania żądania')
      setLoading(false)
    }
  }

  return (
    <div className="pub-form-box">
      <h1 className="pub-h2">Resetuj hasło</h1>
      <p className="pub-muted" style={{ marginBottom: 28 }}>Wyślemy Ci link do ustawienia nowego hasła.</p>

      <div className="pub-card">
        {success ? (
          <div>
            <h2 className="pub-h3">E-mail wysłany</h2>
            <p className="pub-muted">Sprawdź skrzynkę. Link do resetowania hasła wygaśnie za 24 godziny.</p>
            <p className="pub-small">Jeśli nie widzisz wiadomości, sprawdź folder SPAM.</p>
            <p className="pub-small">Za 3 sekundy przeniesiemy Cię na stronę logowania.</p>
          </div>
        ) : (
          <>
            {error && <Message variant='danger'>{error}</Message>}
            {loading && <Loader />}

            <Form onSubmit={handleSubmit}>
              <Form.Group className="mb-4" controlId="forgot-email">
                <Form.Label>Adres e-mail</Form.Label>
                <Form.Control
                  type='email'
                  placeholder='twoj.email@example.com'
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                  disabled={loading}
                />
                <Form.Text className="pub-small">Wpisz adres e-mail powiązany z Twoim kontem.</Form.Text>
              </Form.Group>

              <button type="submit" className="pub-btn w-100" disabled={loading}>
                {loading ? 'Wysyłanie…' : 'Wyślij link'}
              </button>
            </Form>
          </>
        )}
      </div>

      <p style={{ marginTop: 24 }}>
        <Link to="/login" className="pub-link">Wróć do logowania</Link>
      </p>
    </div>
  )
}

export default ForgotPassword
